// extracted by mini-css-extract-plugin
export default {"item":"MenuItem_item__kcDpx","button":"MenuItem_button__si0dH","icon":"MenuItem_icon__GjmaB"};